import { render, staticRenderFns } from "./AControl.vue?vue&type=template&id=56da0756&"
import script from "./AControl.vue?vue&type=script&lang=js&"
export * from "./AControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports